import { isNotDefined } from '@sgme/fp';
import { FormattedNumber } from 'react-intl';

import { useOptionSelector } from '@/App/tiles/Option/OptionContext.ts';
import { selectOptionQuoteLegs } from '@/store/option/selectors/optionSelectors.ts';
import type { LegId } from '@/store/option/state.ts';

export function MidVolatility() {
  const { midVolatility } = useOptionSelector((option) => {
    const tileId = option.properties.tileId;
    const legId: LegId = `${tileId}/0`;
    const legData = selectOptionQuoteLegs(option, legId);

    return { midVolatility: legData?.midVolatility };
  });

  if (isNotDefined(midVolatility?.smiledVolatilityMid)) {
    return null;
  }

  return (
    <div className="p-1 fs-6 text-black bg-light monospace-numbers" data-e2e="mid-volatility">
      M: <FormattedNumber value={midVolatility.smiledVolatilityMid} minimumFractionDigits={3} />
    </div>
  );
}

